import { useState } from "react";
import {
  Button,
  Box,
  TextField,
  Card,
  CardMedia,
  Typography,
} from "@mui/material";
import { UseMenuContent } from "./UseMenuContent";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddMenu(props) {
  const location = useLocation();
  let temp = location.state.menuRes ? location.state.menuRes : [];
  var lastOrderRow = Math.max.apply(
    Math,
    temp.map(function (o) {
      return o.rowIndex;
    })
  );
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, addMenu } = UseMenuContent();
  const [state, setState] = useState({
    parentID: location.state.id,
    title: undefined,
    rowIndex: lastOrderRow != -Infinity ? lastOrderRow + 1 : 1,
    url: undefined,
    advertisements: [],
  });
  const { isSmall } = useBreakpoints();

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/menues" },
          { name: "افزودن منو", url: "/menues/addMenu" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            sx={{ mt: 1, width: "100%" }}
            value={state.title ? state.title : ""}
            error={errorState.title}
            label="نام منو"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <TextField
            sx={{ mt: 1, width: "100%", input: { direction: "rtl" } }}
            value={state.url ? state.url : ""}
            error={errorState.url}
            label="آدرس منو"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, url: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 5"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 5"}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Typography variant="subtitle2" sx={{ mr: 1 }}>
            آیکن منو :
          </Typography>
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "100px", height: "100px" }}>
                <Card
                  sx={{
                    p: 2,
                    border: "2px dashed #0073E7",
                    borderRadius: 4,
                    boxShadow: 0,
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.url ? imgState.url : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 6"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                addMenu(state, imgState.file, () => {
                  navigate("/menues", {
                    state: location.state,
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/menues", {
                state: location.state,
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
